import React from 'react';
import { UIUser } from 'types';
import { Img } from 'react-image';
import classNames from 'classnames';
import { stringAvatar } from 'shared-utils';
import { Avatar, Tooltip } from 'flowbite-react';
import useDisclosure from 'src/hooks/utils/useDisclosure';
import UploadProfileImage from 'src/components/profile/UploadProfileImage';

interface Props {
	userProfileData: UIUser;
}

const MentorProfilePic = ({ userProfileData }: Props) => {
	const { isOpen, onOpen, onClose } = useDisclosure();
	return (
		<div className="flex w-full flex-col gap-4">
			<div className="relative flex items-center justify-center md:items-center">
				<Avatar
					alt="User Profile"
					placeholderInitials={stringAvatar(userProfileData?.name.trim().toUpperCase() || '')}
					rounded={true}
					img={userProfileData?.profile?.profileImageUrl || ''}
					size={'xl'}
					bordered
					className={classNames(!userProfileData?.profile?.profileImageUrl && 'profile-avatar-div', 'text-3xl')}
				/>
				<Img
					className="absolute bottom-[-10px] left-0 right-0 mx-auto cursor-pointer"
					src={'/assets/addIcon.svg'}
					alt="addIcon"
					width={28}
					height={28}
					onClick={onOpen}
				/>
			</div>
			{/* User Name, email, phone info Container*/}
			<div className="flex w-full flex-col items-center gap-[2px]">
				<div className="flex flex-col justify-center dark:text-white">
					{/* Adding tootlip for user name */}
					{userProfileData && userProfileData?.name.length > 21 ? (
						<Tooltip content={userProfileData?.name}>
							<p className="mx-auto w-full max-w-[200px] truncate text-center font-inter text-[24px] font-[700] md:max-w-[265px]">
								{userProfileData?.name}
							</p>
						</Tooltip>
					) : (
						<p className="font-inter text-[24px] font-[700]">{userProfileData?.name}</p>
					)}
				</div>
				<div className="text-[16px] text-gray-500 dark:text-[#d2d2d7]">{userProfileData?.phone || ''}</div>
				<div className="flex flex-col justify-center text-[16px] text-gray-500 dark:text-[#d2d2d7]">
					{/* Adding tootlip for user email */}
					{userProfileData && userProfileData?.email?.length > 24 ? (
						<Tooltip content={userProfileData?.email}>
							<p className="mx-auto w-full  max-w-[200px] truncate text-center font-inter text-[20px] font-[500] md:max-w-[265px]">
								{userProfileData?.email}
							</p>
						</Tooltip>
					) : (
						<p className="font-inter font-[500]">{userProfileData?.email}</p>
					)}
				</div>
			</div>
			<UploadProfileImage isOpen={isOpen} onClose={onClose} />
		</div>
	);
};

export default MentorProfilePic;
